export default "__VITE_ASSET__MUpTUAwm__"